import { render, staticRenderFns } from "./RetailerType.vue?vue&type=template&id=c0403f3c&scoped=true"
import script from "./RetailerType.vue?vue&type=script&lang=js"
export * from "./RetailerType.vue?vue&type=script&lang=js"
import style0 from "./RetailerType.vue?vue&type=style&index=0&id=c0403f3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0403f3c",
  null
  
)

export default component.exports